export const navList = [
  {
    id: 1,
    path: "/",
    text: "Home",
  },
  {
    id: 2,
    path: "/about",
    text: "About",
  },
  {
    id: 3,
    path: "/services",
    text: "Services",
  },
  {
    id: 4,
    path: "/rooms",
    text: "Rooms",
  },
  {
    id: 5,
    path: "/explore",
    text: "Explore",
    subItems: [
      {
        id: 51,
        path: "/gallery",
        text: "Photo Gallery",
      },
      {
        id: 52,
        path: "/attractions",
        text: "Nearby Attractions",
      },
      {
        id: 53,
        path: "/testimonials",
        text: "Guest Reviews",
      },
    ],
  },
  {
    id: 6,
    path: "/contact",
    text: "Contact",
  },
];


export const socialIcons = [
  {
    icon: <i className="fab fa-instagram"></i>,
    link: "https://www.instagram.com/harikunjresort/",
  },
  {
    icon: <i className="fab fa-facebook-f"></i>,
    link: "https://www.facebook.com/harikunjresort/",
  },
  {
    icon: <i className="fab fa-youtube"></i>,
    link: "https://www.youtube.com/@harikunjresort",
  },
  {
    icon: <i className="fas fa-map-marker-alt"></i>,
    link: "https://www.google.com/maps?q=Gopal+Badi,+Chopasni,+Jodhpur,+342008,+Rajasthan",
    location: "Gopal Badi, Chopasni, Jodhpur, 342008 Rajasthan",
  },
];


export const carouselData = [
  {
    img: "/assets/img/carousel-1.jpg", // Ensure image path is public
    title: "Experience Regal Luxury in the Blue City Jodhpur",
    subtitle: "Royal Heritage Stay",
    btn1: "Our Rooms",
    btn2: "Book Room",
    btn1Link: "/rooms",
    btn2Link: "showPopup",
  },
  {
    img: "/assets/img/carousel-2.jpg",
    title: "A Serene Oasis of Rajasthan Hospitality & Elegance",
    subtitle: "Lush Lawns & Majestic Views",
    btn1: "Our Rooms",
    btn2: "Book Room",
    btn1Link: "/rooms",
    btn2Link: "showPopup",
  },
];


export const about = [
  {
    icon: <i className="fa fa-hotel fa-2x text-primary mb-2"></i>,
    text: "Rooms",
    count: "20",
  },
  {
    icon: <i className="fa fa-users fa-2x text-primary mb-2"></i>,
    text: "Staffs",
    count: "100",
  },
  {
    icon: <i className="fa fa-users-cog fa-2x text-primary mb-2"></i>,
    text: "Clients",
    count: "432",
  },
];

export const services = [
  {
    icon: <i className="fa fa-bed"></i>,
    name: "Rooms & Suites",
    discription:
      "Thoughtfully designed rooms and suites with plush bedding, private balconies, and calming interiors for a restful escape.",
  },
  {
    icon: <i className="fa fa-coffee"></i>,
    name: "Dining & Restaurant",
    discription:
      "From authentic Rajasthani flavours to global cuisine, enjoy chef-curated menus in an elegant, warm dining ambience.",
  },
  {
    icon: <i className="fa fa-leaf"></i>,
    name: "Spa & Wellness",
    discription:
      "Signature spa therapies, steam, and relaxation rituals crafted to rejuvenate your body, mind, and soul.",
  },
  {
    icon: <i className="fa fa-tint"></i>,
    name: "Pool & Recreation",
    discription:
      "Unwind by the pool, enjoy recreational activities, and experience leisure spaces designed for all age groups.",
  },
  {
    icon: <i className="fa fa-star"></i>,
    name: "Events & Celebrations",
    discription:
      "Host weddings, socials, and corporate events with bespoke décor, curated menus, and end-to-end event support.",
  },
  {
    icon: <i className="fa fa-heartbeat"></i>,
    name: "Gym & Yoga",
    discription:
      "Stay aligned with your fitness routine through a well-equipped gym, yoga sessions, and open spaces to breathe.",
  },
];

export const attraction = [
  {
    image: "/assets/img/Kaylana-Lake.jpg",
    name: "Kaylana Lake",
    designation: "A picturesque man-made lake, ideal for a serene escape and bird-watching amidst tranquil nature.",
    location: "Kaylana Lake, Jodhpur, Rajasthan",
  },
  {
    image: "/assets/img/Umaid-Bhawan-Palace.jpg",
    name: "Umaid Bhawan Palace",
    designation: "A stunning palace turned museum and luxury hotel, showcasing the royal heritage of Jodhpur.",
    location: "Umaid Bhawan, Jodhpur, Rajasthan",
  },
  {
    image: "/assets/img/Mehrangarh-Fort.jpg",
    name: "Mehrangarh Fort",
    designation: "A magnificent fortress towering over Jodhpur, with stunning architecture, rich history, and breathtaking views.",
    location: "Mehrangarh Fort, Jodhpur, Rajasthan",
  },
  {
    image: "/assets/img/Ummed-Sagar-Bandh.jpg",
    name: "Umaid Sagar Bandh",
    designation: "Umaid Sagar Bandh, a peaceful reservoir near Jodhpur, located just 1.5 km away, vital for the region.",
    location: "Umaid Sagar, Jodhpur, Rajasthan",
  },
];



export const footerItem = [
  {
    id: 1,
    header: "Company",
    link: [
      {
        name: "About Us",
        path: "/about",
      },
      {
        name: "Contact Us",
        path: "/contact",
      },
      {
        name: "Terms & Conditions",
        path: "/terms-and-conditions",
      },
      {
        name: "Privacy Policy",
        path: "/privacy-policy",
      },
    ],
  },
  {
    id: 2,
    header: "Services",
    UnitItem: [
      {
        name: "Food & Restaurant",
      },
      {
        name: "Spa & Fitness",
      },
      {
        name: "Sports & Gaming",
      },
      {
        name: "Event & Party",
      },
      {
        name: "GYM & Yoga",
      },
    ],
  },
];



export const footerContact = [
  {
    icon: (
      <a
        href="https://www.google.com/maps?q=Gopal+Badi,+Chopasni,+Jodhpur,+342008,+Rajasthan"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="fa fa-map-marker-alt me-3"></i>
      </a>
    ),
    name: "Gopal Badi, Chopasni, Jodhpur, 342008 Rajasthan",
  },
  {
    icon: (
      <a href="tel:+919602588882" rel="noopener noreferrer">
        <i className="fa fa-phone-alt me-3"></i>
      </a>
    ),
    name: "+91 9602588882/3",
  },
  {
    icon: (
      <a href="mailto:reservation@harikunjresort.com">
        <i className="fa fa-envelope me-3"></i>
      </a>
    ),
    name: "reservation@harikunjresort.com",
  },
];




export const contact = [
  {
    icon: <i className="fa fa-envelope-open text-primary me-2"></i>,
    title: "Booking",
    email: "reservation@harikunjresort.com",
  },
  {
    icon: <i className="fa fa-envelope-open text-primary me-2"></i>,
    title: "Technical",
    email: "reservation@harikunjresort.com",
  },
  {
    icon: <i className="fa fa-envelope-open text-primary me-2"></i>,
    title: "General",
    email: "reservation@harikunjresort.com",
  },
];


export const testimonial = [
  {
    description:
      "A perfect blend of comfort and elegance. The staff went above and beyond to make our stay memorable. The rooms were spotless, the food was outstanding, and the garden area was like a little paradise. Highly recommended for both business and leisure trips.",
    name: "Vaishali Rana",
    profession: "Entrepreneur",
    rating: 5.0,
    date: "July 2026",
    icon: (
      <i className="fas fa-quote-right fa-3x text-primary position-absolute end-0 bottom-0 me-4 mb-n1"></i>
    ),
    img: "/assets/img/testi_vaishali_1784734092922.jpg",
  },
  {
    description:
      "From check-in to checkout, everything was seamless. Beautiful rooms, delicious food, and a peaceful ambience. The Rajasthani thali they serve for dinner is absolutely divine — you can taste the authenticity in every bite. This is my go-to stay in Jodhpur now.",
    name: "Ashok Kumar",
    profession: "Marketing Manager",
    rating: 4.5,
    date: "May 2026",
    icon: (
      <i className="fas fa-quote-right fa-3x text-primary position-absolute end-0 bottom-0 me-4 mb-n1"></i>
    ),
    img: "/assets/img/testi_ashok_1784734108896.jpg",
  },
  {
    description:
      "As a photographer, I loved the scenic views around the property. The resort is stunning, and the hospitality makes you feel at home. I got some of my best sunset shots from the terrace — the Mehrangarh Fort in the distance was magical.",
    name: "Vinod",
    profession: "Freelance Photographer",
    rating: 4.5,
    date: "June 2026",
    icon: (
      <i className="fas fa-quote-right fa-3x text-primary position-absolute end-0 bottom-0 me-4 mb-n1"></i>
    ),
    img: "/assets/img/testi_vinod_1784734124863.jpg",
  },
  {
    description:
      "The rooms are spacious, the staff is polite, and the service is top-notch. The peaceful surroundings made it a perfect family getaway. My kids absolutely loved the garden area, and my parents appreciated the quiet and clean environment.",
    name: "Manish Mehta",
    profession: "Software Engineer",
    rating: 4.0,
    date: "February 2026",
    icon: (
      <i className="fas fa-quote-right fa-3x text-primary position-absolute end-0 bottom-0 me-4 mb-n1"></i>
    ),
    img: "/assets/img/testi_manish_1784734139807.jpg",
  },
  {
    description:
      "We organized a small corporate offsite here and everything from food to arrangements was handled flawlessly. The conference space was well-equipped, the Wi-Fi was excellent, and the team-building activities they suggested were a hit. Our team had a fantastic experience.",
    name: "Rahul Verma",
    profession: "HR Manager",
    rating: 5.0,
    date: "July 2026",
    icon: (
      <i className="fas fa-quote-right fa-3x text-primary position-absolute end-0 bottom-0 me-4 mb-n1"></i>
    ),
    img: "/assets/img/testi_rahul_1784734156707.jpg",
  },
  {
    description:
      "The resort has the right balance of luxury and warmth. The staff made sure our anniversary trip felt truly special — from the flower arrangement in the room to the candlelight dinner setup in the garden. Couldn't have asked for anything better.",
    name: "Rajesh",
    profession: "Couple Traveller",
    rating: 4.5,
    date: "March 2026",
    icon: (
      <i className="fas fa-quote-right fa-3x text-primary position-absolute end-0 bottom-0 me-4 mb-n1"></i>
    ),
    img: "/assets/img/testi_rajesh_1784734174589.jpg",
  },
  {
    description:
      "We were a group of eight friends on a Rajasthan road trip and HariKunj was honestly the highlight of our journey. The rooms were comfortable, the rooftop view was spectacular at night, and the staff helped us plan our Jodhpur sightseeing itinerary. Will definitely come back!",
    name: "Priya Sharma",
    profession: "Travel Blogger",
    rating: 5.0,
    date: "January 2026",
    icon: (
      <i className="fas fa-quote-right fa-3x text-primary position-absolute end-0 bottom-0 me-4 mb-n1"></i>
    ),
    img: "/assets/img/testi_priya_1784734192384.jpg",
  },
  {
    description:
      "I travel across India for work and have stayed at countless hotels, but HariKunj stands out. The attention to detail is remarkable — from the welcome drink to the perfectly pressed bedsheets. It felt more like a heritage home than a hotel. Truly five-star service at an affordable price.",
    name: "Deepak Joshi",
    profession: "Sales Director",
    rating: 4.5,
    date: "April 2026",
    icon: (
      <i className="fas fa-quote-right fa-3x text-primary position-absolute end-0 bottom-0 me-4 mb-n1"></i>
    ),
    img: "/assets/img/testi_deepak_1784734208556.jpg",
  },
  {
    description:
      "My mother insisted we stay somewhere peaceful during our Jodhpur visit, and HariKunj was the perfect choice. The property is away from the city noise, the staff treated my elderly parents with so much care, and the home-cooked meals reminded us of our own kitchen. A heartfelt thank you to the entire team.",
    name: "Sunita Agarwal",
    profession: "School Principal",
    rating: 5.0,
    date: "June 2026",
    icon: (
      <i className="fas fa-quote-right fa-3x text-primary position-absolute end-0 bottom-0 me-4 mb-n1"></i>
    ),
    img: "/assets/img/testi_sunita_1784734226048.jpg",
  },
  {
    description:
      "Booked this resort for our pre-wedding photoshoot and it turned out to be the best decision. The architecture, the lush green garden, and the warm lighting in the evening created the most stunning backdrops. Our photographer was thrilled with the location. Thank you, HariKunj!",
    name: "Ankit & Neha",
    profession: "Newly Engaged Couple",
    rating: 4.5,
    date: "February 2026",
    icon: (
      <i className="fas fa-quote-right fa-3x text-primary position-absolute end-0 bottom-0 me-4 mb-n1"></i>
    ),
    img: "/assets/img/testi_ankit_neha_1784734243397.jpg",
  },
  {
    description:
      "What impressed me the most was how genuine the hospitality was. The manager personally came to check if everything was alright during our stay. The dal baati churma served at dinner was the best I've had in Jodhpur. Simple, honest, and unforgettable experience.",
    name: "Arvind Patel",
    profession: "Retired Professor",
    rating: 4.0,
    date: "May 2026",
    icon: (
      <i className="fas fa-quote-right fa-3x text-primary position-absolute end-0 bottom-0 me-4 mb-n1"></i>
    ),
    img: "/assets/img/testi_arvind_1784734279003.jpg",
  },
  {
    description:
      "I was nervous about traveling solo as a woman, but the staff at HariKunj made me feel completely safe and welcome. They arranged a local guide for me, recommended authentic eateries, and even packed snacks for my early morning departure. This kind of hospitality is rare to find.",
    name: "Meera Kapoor",
    profession: "Content Creator",
    rating: 5.0,
    date: "July 2026",
    icon: (
      <i className="fas fa-quote-right fa-3x text-primary position-absolute end-0 bottom-0 me-4 mb-n1"></i>
    ),
    img: "/assets/img/testi_meera_1784734296727.jpg",
  },
  {
    description:
      "We celebrated our parents' 50th anniversary here and the team went out of their way to make it special. They decorated the dining area beautifully, baked a custom cake, and even arranged folk musicians for the evening. My parents were moved to tears. Thank you for creating such a precious memory.",
    name: "Vikram Singh",
    profession: "Business Owner",
    rating: 5.0,
    date: "March 2026",
    icon: (
      <i className="fas fa-quote-right fa-3x text-primary position-absolute end-0 bottom-0 me-4 mb-n1"></i>
    ),
    img: "/assets/img/testi_vikram_1784734315958.jpg",
  },
  {
    description:
      "The location is ideal — close enough to Mehrangarh Fort and the old city, yet tucked away in a quiet corner. I spent two days just reading in the garden with a cup of chai. Sometimes you don't need fancy amenities, just peace and good people. HariKunj delivers both.",
    name: "Nandini Rao",
    profession: "Author & Poet",
    rating: 4.5,
    date: "April 2026",
    icon: (
      <i className="fas fa-quote-right fa-3x text-primary position-absolute end-0 bottom-0 me-4 mb-n1"></i>
    ),
    img: "/assets/img/testi_nandini_1784734332941.jpg",
  },
  {
    description:
      "Third time staying here and it gets better every visit. This time I brought my international colleagues and they were absolutely blown away by the Rajasthani decor, the warmth of the staff, and the incredible food spread. HariKunj has become my official recommendation for anyone visiting Jodhpur.",
    name: "Karan Malhotra",
    profession: "IT Consultant",
    rating: 5.0,
    date: "January 2026",
    icon: (
      <i className="fas fa-quote-right fa-3x text-primary position-absolute end-0 bottom-0 me-4 mb-n1"></i>
    ),
    img: "/assets/img/testi_karan_1784734351490.jpg",
  },
  {
    description:
      "We had our daughter's first birthday celebration at HariKunj and it was absolutely magical. The staff helped with decorations, arranged a small play area for the kids, and made sure the food was kid-friendly too. Every guest complimented the venue. Can't thank the team enough!",
    name: "Pooja & Rohit Gupta",
    profession: "Young Parents",
    rating: 4.5,
    date: "June 2026",
    icon: (
      <i className="fas fa-quote-right fa-3x text-primary position-absolute end-0 bottom-0 me-4 mb-n1"></i>
    ),
    img: "/assets/img/testi_pooja_rohit_1784734369111.jpg",
  },
];


export const roomItems = [
  {
    img: "/assets/img/image-1.jpg",
    price: "₹3999/night",
    name: "Standard Room",
    starCount: 5,
    description:
      "Enjoy peaceful comfort in our elegant Standard Room. Features a cozy, plush bed and a private balcony overlooking our lush green lawns — a serene heritage oasis.",
    yellowbtn: "View Detail",
    darkbtn: "Book Now",
    darkbtnLink: "/popup",
  },
  {
    img: "/assets/img/image-3.jpg",
    price: "₹4999/night",
    name: "Deluxe Room",
    starCount: 5,
    description:
      "Unwind in our luxury Deluxe Room, featuring a magnificent king-sized bed, high-speed Wi-Fi, and a private terrace with expansive views of Jodhpur's historic landscape.",
    yellowbtn: "View Detail",
    darkbtn: "Book Now",
  },
  {
    img: "/assets/img/image-2.jpg",
    price: "₹7999/night",
    name: "Super Deluxe",
    starCount: 5,
    description:
      "Experience the pinnacle of royal heritage in our spacious Super Deluxe Suite, featuring a grand living area, a kitchenette, and premium heritage-inspired modern interiors.",
    yellowbtn: "View Detail",
    darkbtn: "Book Now",
  },
];

export const facility = [
  {
    icon: <i className="fa fa-bed text-primary me-2"></i>,
    quantity: 2,
    facility: "bed",
  },
  {
    icon: <i className="fa fa-bath text-primary me-2"></i>,
    quantity: 1,
    facility: "bath",
  },
  {
    icon: <i className="fa fa-wifi text-primary me-2"></i>,
    facility: "Wifi",
  },
];
